import { HttpResponse } from "@angular/common/http";
import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { Constants } from "../app.constants";
import { AppService } from "../app.service";
import { StorageService } from "../app.storage.service";
import { AttendanceConstant } from "./attendance.constant";
import { AttendanceService } from "./attendance.service";

declare var $: any;
declare var moment: any;
@Component({
    selector: 'app-attendance',
    templateUrl: './attendance.component.html',
    styleUrls: ['./attendance.component.css']
})

export class AttendnaceComponent{
    constructor(
        private router: Router,
        private attendnaceService: AttendanceService,
        private storageService: StorageService,
        private appService: AppService,
        private attendanceService: AttendanceService
    ){ }

    attendanceDate: number = moment().toDate().getTime()/1000 |0;

    // attendnaceTypeList: any[] = AttendanceConstant.ATTENDNACE_TYPE_LIST;
    attendnaceTypeList: any[] = [];
    attendnaceTypeMap: any = {};
    selectedLeaveType: any = null;

    userData: any = null;
    userTypeMap = Constants.USER_TYPE;
   
  

    async ngOnInit(){
        // console.log("hchjsjhcjh")
        var userData = this.storageService.getDataFromLocalStorage(Constants.STORAGE_KEY.USER_INFO);
        this.userData = userData;

        let data = await this.appService.getAttendnaceTypeObject().catch(()=>{});
        if(data){
            this.attendnaceTypeList = data.list;
            this.attendnaceTypeMap = data.map;

            this.selectedLeaveType = this.attendnaceTypeList[0];
        }
      
       
    }
   
    ngAfterViewInit(){
        $(".content").mCustomScrollbar("update");
    }

    navigateToLeaveApplication(){
        let currentRoute = this.router.url;
        this.router.navigate(['home/attendance/leave-application'], {queryParams: {currentRoute: currentRoute.substring(1)}});
    }

    openMarkAttenPanel(){
        this.selectedLeaveType = this.attendnaceTypeList[0];
        this.initializeDatepicker();
    }

    closeAttendancePanel(){
        this.selectedLeaveType = this.attendnaceTypeList[0];
        $("#markattendModal").modal("hide");
    }

    initializeDatepicker(){
            var scope = this;
    
            $(function () {
                var start = moment();
                var end = moment();
                
                function cb(start, end) {
                    $("#reportrange input").val(start.format("DD/MM/YYYY"));
                    scope.attendanceDate = start.toDate().getTime() / 1000 | 0;
                  // console.log(scope.attendanceDate);
                }
    
                $("#reportrange").daterangepicker({
                    singleDatePicker: true,
                    showDropdowns: true,
                    parentEl: '.singleDatepickerClasss',
                    opens: 'left',
                    startDate: start,
                    minDate:  moment().startOf('month').subtract(7, 'days'),
                    maxDate: moment(),
                    locale: {
                        format: "M/DD hh:mm A"
                    },
                    isCustomDate: function (d) {
                        // var timestamp = d.startOf('day').toDate().getTime() / 1000 | 0;
                        // var map = scope.userDayActivityMap[timestamp];
                        // if (map) {
                        //     var keys = Object.keys(map);
                        //     for (let key of keys) {
                        //         if (map[key]) {
                        //             return "act";
                        //         }
                        //     }
                        //     return "";
                        // }
                    },
                    // customClass : 'sample',
                },
                    cb
                );
    
                cb(start, end);
              
    
            });
    }

    onLeaveTypeChange(){
        // console.log(this.selectedLeaveType)
    }

    onAttendanceMark(){
      
        var CurrentDate = moment().toDate().getTime() / 1000 | 0;
        var minDate = moment().startOf('month').toDate().getTime() / 1000 | 0;
        let attendnaceData = {};
        if(!this.attendanceDate){
            this.appService.showInfoPopup("Message", "Select attendance date");
            return;
        }
        else{
            if(this.attendanceDate > CurrentDate){
                this.appService.showInfoPopup("Warning", "You cannot mark attendance for future date!");
                return;
            }
            if(this.attendanceDate < minDate){
                this.appService.showInfoPopup("Warning", "You cannot mark attendance for previous month!");
                return;
            }
        }
    
        attendnaceData['timestamp'] = this.attendanceDate;

        if(!this.selectedLeaveType){
            this.appService.showInfoPopup("Message", "Select attendance type.");
            return;
        }
        attendnaceData['mark'] = this.selectedLeaveType.id;

        this.attendnaceService.saveAttendnace(attendnaceData)
            .subscribe((res: HttpResponse<any>) =>{
                // console.log(res.status)
                this.appService.showSuccessPopup("Success", "Attendance marked successfully.");
                this.attendnaceService.markAttendanceSubject.next(Math.random());
                this.closeAttendancePanel();
            }, (err)=>{
                console.log(err)
                if(err.status== 406){
                    this.appService.showErrorPopup("Warning","Approved Attendance can not be updated");
                    return;
                }else{
                    this.appService.showErrorPopup("Error", "Something went wrong.");
                    return
                }
              
            })
    }

    keydown(event){
        event.stopImmediatePropagation();
        event.returnValue = false;
    }

    
}